import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import { Image } from "hesus-ui-kit";
import {
  RefrentInfo,
  SubsituteInfo,
  GridRowNoGap,
  FlexRow,
} from "./PersonDetail.styled";
import "../../PersonInChargeList.scss";

import { DivToolTip } from "@utils/extra-style";

const PersonDetail = (props) => {
  const { t, data, personIcon, iconTitle } = props;
  const tooltipId = `department-tooltip-${data?.id}`;
  const tooltipAnchor = `#department-tooltip-${data?.id}`;
  const countText = data?.count > 0 ? "..." : "";

  const wordLimit = (substitutes) => {
    return substitutes
      .map((substitute, i) => {
        return substitute?.firstName + " " + substitute?.lastName;
      })
      .join(", ");
  };

  return (
    <FlexRow>
      <Image
        src={personIcon}
        alt={iconTitle}
        title={iconTitle}
        className="personInCharge-list__person-detail-image-icon"
      />
      <GridRowNoGap column="1fr">
        <RefrentInfo color="#767676" paddingLeft="10px">
          {data?.main?.firstName
            ? data.main.firstName + " " + data.main.lastName
            : "-"}
        </RefrentInfo>
        <SubsituteInfo color="#767676" paddingLeft="10px">
          {!!data?.substitutes && (
            <>
              <span id={tooltipId}>
                {wordLimit(data.substitutes).slice(0, 35)}
              </span>
              <Tooltip
                anchorSelect={tooltipAnchor}
                style={DivToolTip}
                content={wordLimit(data.substitutes)}
              />
            </>
          )}
          {(!data?.substitutes || data?.substitutes.length === 0) && "-"}
        </SubsituteInfo>
      </GridRowNoGap>
    </FlexRow>
  );
};
PersonDetail.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PersonDetail);
